import { httpBackOfficeUtil } from "./httpBackOfficeUtil"
import { createCommonResult, createResult, ErrorCodes } from "./resultUtil"

export const orders = {
    getListInstallation,
    getListQueue,
    getQueue,
    completeOrder,
    updateOrder,
    getOrderDetail
}

async function getListQueue({
    state = "ACTIVE",
    search_value,

} = {},) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/orders/queues',
            queryParams: {
                state,
                search_value,
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getMyOrders: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getQueue(id) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: `/v2/orders/queues/${id}`,
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getQueue: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getListInstallation({
    page = 1,
    size = 10,
    sort = "CREATED_DATE",
    order = 'DESC',
    supply_method = "DIRECT_SALE",
    stage_id,
    custom_fields,
    include_custom_fields,
    include_total = true,
    search_value

} = {},) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/orders',
            queryParams: {
                page,
                size,
                sort,
                order,
                supply_method,
                stage_id,
                custom_fields,
                include_custom_fields,
                include_total,
                search_value
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getInstallations: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function completeOrder(order_id) {
    try {
        let response = await httpBackOfficeUtil.put({
            resourcePath: '/v2/orders/' + order_id + '/actions',
            withAccessToken: true,
            body: {
                action: "COMPLETE"
            },
        });
        return createCommonResult(response);
    } catch (error) {
        console.log("AAAA completeOrder: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}

async function updateOrder({
    order_id,
    custom_fields,
    notes
}={}) {
    try {
        let response = await httpBackOfficeUtil.put({
            resourcePath: '/v2/orders/' + order_id,
            withAccessToken: true,
            body: {
                custom_fields,
                notes
            },
        });
        return createCommonResult(response);
    } catch (error) {
        console.log("AAAA updateOrder: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}

async function getOrderDetail(id) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: `/v2/orders/${id}`,
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getOrderDetail: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}